import { render, staticRenderFns } from "./HandsonTable.vue?vue&type=template&id=59b64a93&"
import script from "./HandsonTable.vue?vue&type=script&lang=js&"
export * from "./HandsonTable.vue?vue&type=script&lang=js&"
import style0 from "handsontable/dist/handsontable.full.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./HandsonTable.vue?vue&type=style&index=1&id=59b64a93&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports